import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clear-orbit-form',
  templateUrl: './clear-orbit-form.component.html',
  styleUrls: ['./clear-orbit-form.component.scss']
})
export class ClearOrbitFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

  goToApplication() {
    window.open('https://suppliercollaboration.ge-energy.com/scp/endeavour/disclaimer.do');
  }

}
